import { SystemIcon, getSvgFromSystem } from '@helpers/systemIcons';
import * as React from 'react';
import S from './Breadcrumb.styles';
const Breadcrumb = ({ items, hideOnMobile }) => {
    if (!items) {
        return null;
    }
    return (React.createElement(S.Container, { id: "lp-breadcrumbs", "data-no-mobile": hideOnMobile }, items.map((item, i) => (React.createElement(S.Item, { key: `breadcrumb-${i}` }, i !== items.length - 1 ? (React.createElement(React.Fragment, null,
        React.createElement(S.ItemLink, { href: item.url }, item.text),
        getSvgFromSystem(SystemIcon.ChevronRight))) : (React.createElement(S.CurrentItem, null, item.text)))))));
};
export default Breadcrumb;
